// import { Component, input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
// import { CommonModule } from '@angular/common';

// @Component({
//   selector: 'app-article-preview',
//   standalone: true,
//   imports: [CommonModule],
//   templateUrl: './article-preview.component.html',
//   styleUrl: './article-preview.component.scss'
// })
// export class ArticlePreviewComponent implements OnInit, OnChanges {

//   article = input<string>('');

//   ngOnInit(): void {
//     console.log(this.article())
//   }

//   ngOnChanges(changes: SimpleChanges): void {
//     if (changes['article']) {
//       console.log(changes)
//     }
//   }
// }

import { Component, Input, OnChanges, SimpleChanges, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-article-preview',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './article-preview.component.html'
})
export class ArticlePreviewComponent implements OnChanges {
  #sanitizer = inject(DomSanitizer);
  @Input() article: string = '';
  articleHtml: any = ''; // = signal<SafeHtml>('');

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['article']) {
      this.articleHtml = this.#sanitizer.bypassSecurityTrustHtml(this.article);
      // console.log('article changed:', changes['article'].currentValue);
    }
  }
}
